import dayjs from "@gtmhub/dayjs";

export const manualStartOfDay = (isoDateString: string): string => {
  const tIndex = isoDateString.indexOf("T");
  return isoDateString.substring(0, tIndex) + "T00:00:00.000Z";
};

export const manualEndOfDay = (isoDateString: string): string => {
  const tIndex = isoDateString.indexOf("T");
  return isoDateString.substring(0, tIndex) + "T23:59:59.000Z";
};

export const adjustLocalDate = (date: dayjs.Dayjs): dayjs.Dayjs => {
  const timezoneOffsetMinutes = dayjs().utcOffset();
  return date.add(timezoneOffsetMinutes, "minutes");
};
